import { IGameAttendances } from "@grassrootly/api";
import { Div, Icon, Label } from "@grassrootly/rn-core";
import { Image } from "react-native";
import { images } from "../../../layout/assets";
import { PlayerRating } from "../../shared";
import { hasScoredOrAssisted } from "../lib";

export default function GameMVP({ mvp }: { mvp: IGameAttendances }) {
  return (
    <Div classNames={["justifyContentCenter", "alignItemsCenter", "mb-{16}", "mt-{8}", "mh-{auto}"]}>
      <Div classNames={["flexRow", "alignItemsCenter", "justifyContentCenter"]}>
        <Image
          style={{ height: 110, width: 110, borderRadius: 110, marginTop: 8 }}
          resizeMode="cover"
          source={mvp.player?.profile_picture ? { uri: mvp.player?.profile_picture } : images.playerAvatar}
        />
        <Div classNames={["ml-{15}"]}>
          <Label type="l1Bold" classNames={["colorPrimaryMain", "fontSize-{18}"]}>
            M V P
          </Label>
          <Label type="l1Bold" numberOfLines={1} ellipsizeMode="tail">
            {mvp.player?.name}
          </Label>
          <Label type="l4Regular" classNames={["mb-{12}"]}>
            Team: {mvp.team == "HOST" ? "Beli" : "Markeri"}
          </Label>
          <Div classNames={["flexRow"]}>
            <Div classNames={[`${hasScoredOrAssisted(mvp) ? "mr-{16}" : ""}`]}>
              {mvp.goals_scored ? (
                <Div classNames={["flexRow", "alignContentCenter", "justifyContentCenter"]}>
                  <Icon name="sports_soccer" classNames={["mr-{2}"]} size={24} />
                  <Label type="l2Regular">{mvp.goals_scored > 1 ? `x${mvp.goals_scored}` : ""}</Label>
                </Div>
              ) : null}
              {mvp.assists_made ? (
                <Div classNames={["flexRow", "alignContentCenter"]}>
                  <Image source={images.assist} style={{ marginRight: 3, height: 14, width: 24, marginTop: 3 }} />
                  <Label type="l2Regular">{mvp.assists_made > 1 ? `x${mvp.assists_made}` : ""}</Label>
                </Div>
              ) : null}
            </Div>
            <Div>
              {typeof mvp.rating == "number" ? (
                <PlayerRating
                  rating={mvp.rating}
                  classNames={[`${hasScoredOrAssisted(mvp) ? "mh-{auto}" : "mr-{auto}"}`, "mb-{auto}"]}
                />
              ) : null}
              <Label type="l3Regular" classNames={["mt-{4}"]}>
                Exp +{mvp.points_earned}
              </Label>
            </Div>
          </Div>
        </Div>
      </Div>
    </Div>
  );
}
